

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import axios from "../src/common/axios";
import qs from 'qs'
import api from './global/netbarapi';//后加网吧
import './plugins/element.js'
import 'font-awesome/css/font-awesome.css'
import './style/element-ui.scss';
import './permission';
import "./global/global.css"
import 'lib-flexible';    //  大小适配  适合不同大小的屏幕  
import "amfe-flexible"; 
import { message} from './global/resetMessage.js';


// 引入echarts
import echarts from 'echarts'

Vue.prototype.$echarts = echarts 
// import VueResource from 'vue-resource'; 
// Vue.use(VueResource); 
Vue.config.productionTip = false
// Vue.prototype.$http = axios.instance1;
// debugger
Vue.prototype.$api = api;//后加网吧
Vue.prototype.$http = axios.instance6;
Vue.prototype.$http3 = axios.instance5;
Vue.prototype.$http2 = axios.instance7;
// Vue.prototype.$api = axios.instance3;    
// Vue.http.options.emulateJSON = true; 
Vue.prototype.$qs=qs

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

Vue.prototype.$message = message;